import { useContext } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import UserContext from "../../context/UserContext.js";
import QrMark from "./QrMark";
import ThemeToggle from "./ThemeToggle";

const LandingNav = ({ dark, onToggleTheme }) => {

    const { user, LSuser } = useContext(UserContext);
    const logged = Boolean(user || LSuser);

  return (
    <nav className="lp-nav">
        <div className="lp-nav-inner">
            <Link to="/" className="lp-logo">
                <span className="lp-logo-mark"><QrMark></QrMark></span>
                MiQRapp
            </Link>

            <div className="lp-nav-links">
                <HashLink to="/#planes" smooth className="lp-nav-link lp-hide-mobile">Precios</HashLink>
                <Link to="/preguntas-frecuentes" className="lp-nav-link lp-hide-mobile">Preguntas</Link>
                <ThemeToggle dark={dark} onToggle={onToggleTheme}></ThemeToggle>
                {
                    logged ?
                    <Link to="/cuenta" className="lp-nav-cta">Mi cuenta</Link> :
                    <>
                        <Link to="/login" className="lp-nav-link">Ingresar</Link>
                        <Link to="/register" className="lp-nav-cta">Crear cuenta</Link>
                    </>
                }
            </div>
        </div>
    </nav>
  )
}

export default LandingNav
